/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';

export const useAvailability = (partNumbers, skipCondition) => {

    const variables = {
        "partnumbers": partNumbers
      };
    

    const PRODUCTS_AVAILABILITY_QUERY = gql`
    query Availability($partnumbers: [ID!]!) {
        availability(partnumbers: $partnumbers) {
        partnumber
        availability {
        status
        }
        }
    }`;

    const {loading, data, error} = useQuery(PRODUCTS_AVAILABILITY_QUERY, {
            variables,
            fetchPolicy: 'network-only',
            skip: skipCondition,
            context:{
              clientName:"product"
            }
          
    })

   return {loading, data, error}

}